import React from 'react';

const Footer = () => {
    return (
        <div>
            <div className='text-center  mt-5 mb-0 bg-secondary p-5px ' >
                <h3> copyright ©Watch Warehouse </h3>
            </div>
        </div>
    );
};

export default Footer;